import React, { useMemo } from 'react';
import { buildList } from 'widgets/ActionMenu/utils';

import "./BladeActions.css";

function Divider(props){
	return <hr {...props} />;
}

export default function BladeActions(props){
	const {
		actionLists,
		actionContext,
	} = props;

	const [menuItems] = useMemo(() => {
		return buildList(actionLists, actionContext, Divider);
	}, [actionLists, actionContext]);

	return (
		<div className="blade-actions">
			{menuItems}
		</div>
	);
}

BladeActions.displayName = "BladeActions";

BladeActions.defaultProps = {
	actionLists: [],
	actionContext: {},
};
